// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-0c60b1d1] {\n  width: 100%;\n  display: flex;\n  border: 1px solid #dddddd;\n  border-radius: 4px;\n}\n.select-file[data-v-0c60b1d1] {\n  padding: 8px 12px;\n  border-radius: 4px;\n  background: #eeeeee;\n  border-right: 1px solid #dddddd;\n}\n.file-name[data-v-0c60b1d1] {\n  padding: 8px 12px;\n  flex: 1;\n  width: 1px;\n}", ""]);
// Exports
module.exports = exports;
